import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { CompanyRolePermissions, Role, UserPermissions } from "./authorization.models";

const BASE_AUTHORIZATION_URL = `${environment.apiUrl}/authorization`;

@Injectable({ providedIn: "root" })
export class AuthorizationService {
  constructor(public _http: HttpClient) { }

  getUserPermissions(): Observable<UserPermissions> {
    return this._http.get<UserPermissions>(BASE_AUTHORIZATION_URL + '/');
  }

  getCompanyRolesPermissions(companyId: number): Observable<CompanyRolePermissions[]> {
    return this._http.get<CompanyRolePermissions[]>(`${BASE_AUTHORIZATION_URL}/${companyId}`);
  }

  getCompanyRoles(companyId: number): Observable<Role[]> {
    return this._http.get<Role[]>(`${BASE_AUTHORIZATION_URL}/${companyId}/roles`);
  }

  setCompanyRolePermission(companyId: number, roleUuid: string, permissionUuid: string, isAllowed: boolean): Observable<{}> {
    return this._http.patch<{}>(`${BASE_AUTHORIZATION_URL}/${companyId}`, {
      role_uuid: roleUuid,
      permission_uuid: permissionUuid,
      is_allowed: isAllowed
    });
  }
}
